var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYear(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ywkta",
    d: "M711 872.5V897h-30v-24.5h4.88c.78-.42 5.64-3.04 8.3-4.71a2.49 2.49 0 0 1 3.63 0c2.67 1.68 7.53 4.3 8.32 4.71zm-15-4.5c-.44 0-.84.2-1.11.5v.01c-.13.14-.26.34-.33.6l-.03.08a1.5 1.5 0 1 0 2.93 0l-.01-.07A1.5 1.5 0 0 0 696 868zm-8.03 4.5h16.06c-1.52-.82-3.74-2.06-5.53-3.12v.12a2.5 2.5 0 1 1-5-.12c-1.8 1.06-4.01 2.3-5.53 3.12zm-5.97 1v2.5h28v-2.5zm28 22.5v-19h-28v19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ywktb",
    d: "M692 881a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ywktc",
    d: "M695.5 881a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ywktd",
    d: "M699 881a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ywkte",
    d: "M702.5 881a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ywktf",
    d: "M706 881a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ywktg",
    d: "M685 885a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ywkth",
    d: "M688.5 885a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ywkti",
    d: "M692 885a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ywktj",
    d: "M695.5 885a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ywktk",
    d: "M699 885a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ywktl",
    d: "M702.5 885a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ywktm",
    d: "M706 885a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ywktn",
    d: "M685 888.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ywkto",
    d: "M688.5 888.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ywktp",
    d: "M692 888.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ywktq",
    d: "M695.5 888.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ywktr",
    d: "M699 888.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ywkts",
    d: "M702.5 888.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ywktt",
    d: "M706 888.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ywktu",
    d: "M685 892.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ywktv",
    d: "M688.5 892.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ywktw",
    d: "M692 892.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ywktx",
    d: "M695.5 892.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ywkty",
    d: "M699 892.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-681 -867)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#ywkta"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-681 -867)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#ywktb"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-681 -867)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#ywktc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-681 -867)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#ywktd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-681 -867)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#ywkte"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-681 -867)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#ywktf"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-681 -867)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#ywktg"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-681 -867)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#ywkth"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-681 -867)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#ywkti"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-681 -867)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#ywktj"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-681 -867)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#ywktk"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-681 -867)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#ywktl"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-681 -867)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#ywktm"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-681 -867)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#ywktn"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-681 -867)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#ywkto"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-681 -867)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#ywktp"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-681 -867)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#ywktq"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-681 -867)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#ywktr"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-681 -867)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#ywkts"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-681 -867)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#ywktt"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-681 -867)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#ywktu"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-681 -867)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#ywktv"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-681 -867)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#ywktw"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-681 -867)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#ywktx"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-681 -867)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#ywkty"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYear);
export default __webpack_public_path__ + "static/media/year.1c562448e3cd496faf79388d5ab9f04f.svg";
export { ForwardRef as ReactComponent };